export default __webpack_public_path__ + "static/media/COW.faf8eb8f.wav";